import { ContentLibraryScreen } from "types";
import { createScreen } from "utils/createScreen";

export const ContentLibraryDefinition = createScreen({
  name: ContentLibraryScreen,
  path: "/content-library",
  routePath: ["/content-library/*"],
  accessPath: "contentLibrary",
});
